import { Value, FoundationIndex } from "./types";

// Card deck constants
export const VALUES: Value[] = [
  "A",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "J",
  "Q",
  "K",
];

// Foundation sequences for each pile
export const FOUNDATION_SEQUENCES: Record<FoundationIndex, Value[]> = {
  0: ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"],
  1: ["2", "4", "6", "8", "10", "Q", "A", "3", "5", "7", "9", "J", "K"],
  2: ["3", "6", "9", "Q", "2", "5", "8", "J", "A", "4", "7", "10", "K"],
  3: ["4", "8", "Q", "3", "7", "J", "2", "6", "10", "A", "5", "9", "K"],
};
